module.exports = __webpack_public_path__ + "static/media/salesforce.8446666e.svg";